<template>
  <div class="content">
    <div class="login-wrapper">
      <div class="login-title">
        Admin
        <br>
        Quero Pago
      </div>
      <a :href="slackUrl">
        <img
          alt="Sign in with Slack"
          height="40"
          width="172"
          src="https://platform.slack-edge.com/img/sign_in_with_slack@2x.png"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: 'https://slack.com/oauth/authorize',
      queryParams: 'scope=identity.basic,identity.email,identity.team',
    };
  },
  computed: {
    slackUrl() {
      return `${this.baseUrl}?${this.queryParams}&client_id=${this.$slackClientId}`;
    },
  },
};
</script>

<style>
.content {
  background-image:
    linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9)), url('../assets/images/cover.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: row-reverse;
  height: 100vh;
}

.login-wrapper {
  align-items: center;
  display: flex;
  flex-basis: 25%;
  flex-direction: column;
  justify-content: center;
}

.login-title {
  color: #fff;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 16px;
}
</style>
